<template>
	<el-dialog title="文档在线预览" :visible.sync="dialogVisible" :append-to-body="true" width="100%" top="0" :modal="false"
		:fullscreen="true">
		<div class="container">
			<vue-office-docx :src="previewUrl" v-if="fileExtension== 'docx' || fileExtension== 'ppt'" />
			<vue-office-excel style="height: 80vh;" :src="previewUrl" v-else-if="fileExtension == 'xlsx'" />
			<vue-office-pdf :src="previewUrl" @rendered="rendered" v-else-if="fileExtension == 'pdf'" />
			<div class="flex-center" v-else>
				<img :src="previewUrl" style="max-width: 100%;" alt="" />
			</div>
			<div class="watermark" v-if="isWatermark"></div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">关闭</el-button>
		</span>
	</el-dialog>
</template>

<script>
	// 引入
	import PreviewPdf from '@/utils/previewPdf'
	import VueOfficePdf from "@vue-office/pdf";
	import VueOfficeDocx from '@vue-office/docx'
	import VueOfficeExcel from '@vue-office/excel'
	import '@vue-office/docx/lib/index.css'
	import '@vue-office/excel/lib/index.css'
	import axios from 'axios'
	import {
		includes
	} from 'core-js/fn/dict';
	export default {
		name: '',
		props: {
			url: {
				type: String,
				default: ""
			}
		},
		components: {
			VueOfficePdf,
			VueOfficeDocx,
			VueOfficeExcel
		},
		data() {
			return {
				dialogVisible: false,
				previewUrl: '',
				fileExtension: 'pdf',
				isWatermark: true
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			open(url, watermark) {
				const fileExtension = this.getFileExtension(url);
				this.dialogVisible = true
				this.fileExtension = fileExtension
				this.isWatermark = watermark
				if (fileExtension == 'pdf') {
					if (!watermark) {
						return this.previewUrl = url
					}
					this.previewUrl = url
					return
					axios({
						url,
						method: 'GET',
						responseType: 'blob', // 重要：设置响应类型为blob
					}).then((response) => {
						console.log(response, 'responseresponse')
						const blob = new Blob([response.data], {
							type: 'application/pdf'
						});
						new PreviewPdf({
							blob: blob,
							docTitle: new Date().getTime().toString(),
							isAddWatermark: true,
							watermark: {
								type: 'canvas',
								text: '实验教学和教学实验室建设研究'
							}
						}).then((res) => {
							this.previewUrl = res
						})
					}).catch((error) => {
						console.error('下载文档失败:', error);
					});
				} else if (fileExtension == 'docx' || fileExtension == 'xlsx' || fileExtension == 'ppt') {
					this.previewUrl = url
				} else if (['jpg', 'jpeg', 'png', 'webp'].includes(fileExtension)) {
					this.previewUrl = url
				}
			},
			rendered() {
				console.log("渲染完成")
			},
			getFileExtension(filename) {
			  var pattern = /\.([0-9a-z]+)(?:[\?#]|$)/i;
			  var match = pattern.exec(filename);
			  if (match === null) {
			    return '';
			  }
			  return match[1];
			}
		}

	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		height: 100%;
		position: relative;

		.watermark {
			position: absolute;
			z-index: 999999999999;
			left: 0;
			top: 0;
			color: rgba(121, 121, 121, 0.6);
			pointer-events: none;
			right: 0;
			opacity: .5;
			bottom: 0;
			background: url('../../assets/watermark.png');
		}
	}

	::v-deep() {
		.el-dialog__title {
			color: white;
		}

		.el-dialog__close,
		.el-icon,
		.el-icon-close {
			color: white;
		}

		.docx-wrapper,
		.vue-office-pdf-wrapper {
			background-color: #F0F0F0 !important;
		}
	}

	::v-deep(.el-dialog) {
		border-radius: 0 !important;
		overflow: auto !important;
	}
</style>